module.exports = __webpack_public_path__ + "static/media/photoshoot-4.32c00847.jpg";